import React from 'react'
import { ShoppingCart, Star } from 'lucide-react'
import toast from 'react-hot-toast'

const Products = () => {
  const vegetables = [
    {
      name: 'Fresh Tomatoes',
      price: 3.99,
      unit: 'per lb',
      image: 'https://images.pexels.com/photos/1327838/pexels-photo-1327838.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.8
    },
    {
      name: 'Organic Carrots',
      price: 2.49,
      unit: 'per lb',
      image: 'https://images.pexels.com/photos/3650647/pexels-photo-3650647.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.9
    },
    {
      name: 'Green Broccoli',
      price: 4.99,
      unit: 'per lb',
      image: 'https://images.pexels.com/photos/47347/broccoli-vegetable-food-healthy-47347.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.7
    },
    {
      name: 'Fresh Spinach',
      price: 3.49,
      unit: 'per bunch',
      image: 'https://images.pexels.com/photos/2255935/pexels-photo-2255935.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.6
    }
  ]

  const fruits = [
    {
      name: 'Red Apples',
      price: 4.99,
      unit: 'per lb',
      image: 'https://images.pexels.com/photos/102104/pexels-photo-102104.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.9
    },
    {
      name: 'Fresh Oranges',
      price: 3.99,
      unit: 'per lb',
      image: 'https://images.pexels.com/photos/161559/background-bitter-breakfast-bright-161559.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.8
    },
    {
      name: 'Ripe Bananas',
      price: 2.99,
      unit: 'per bunch',
      image: 'https://images.pexels.com/photos/2872755/pexels-photo-2872755.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 4.7
    },
    {
      name: 'Sweet Strawberries',
      price: 5.99,
      unit: 'per lb',
      image: 'https://images.pexels.com/photos/46174/strawberries-berries-fruit-freshness-46174.jpeg?auto=compress&cs=tinysrgb&w=600',
      rating: 5.0
    }
  ]

  const handleAddToCart = (productName) => {
    toast.success(`${productName} added to cart!`, {
      icon: '🛒',
      style: {
        borderRadius: '10px',
        background: '#10b981',
        color: '#fff',
      },
    })
  }

  const ProductCard = ({ product }) => (
    <div 
      data-component-path="client/src/components/Products.jsx" 
      data-component-line="89:7" 
      data-component-id={`client/src/components/Products.jsx:89:7-${product.name}`}
      className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
    >
      <div data-component-path="client/src/components/Products.jsx" data-component-line="94:7" data-component-id={`client/src/components/Products.jsx:94:7-${product.name}`} className="relative h-64 overflow-hidden">
        <img 
          data-component-path="client/src/components/Products.jsx" 
          data-component-line="96:11" 
          data-component-id={`client/src/components/Products.jsx:96:11-${product.name}`}
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
          loading="lazy"
          onError={(e) => {
            e.target.src = 'https://images.pexels.com/photos/1435904/pexels-photo-1435904.jpeg?auto=compress&cs=tinysrgb&w=600'
          }}
        />
        <div data-component-path="client/src/components/Products.jsx" data-component-line="106:9" data-component-id={`client/src/components/Products.jsx:106:9-${product.name}`} className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1">
          <Star data-component-path="client/src/components/Products.jsx" data-component-line="107:11" data-component-id={`client/src/components/Products.jsx:107:11-${product.name}`} className="w-4 h-4 text-yellow-500 fill-yellow-500 flex-shrink-0" />
          <span data-component-path="client/src/components/Products.jsx" data-component-line="108:11" data-component-id={`client/src/components/Products.jsx:108:11-${product.name}`} className="text-sm font-semibold text-gray-900">{product.rating}</span>
        </div>
      </div>
      <div data-component-path="client/src/components/Products.jsx" data-component-line="111:7" data-component-id={`client/src/components/Products.jsx:111:7-${product.name}`} className="p-6">
        <h3 data-component-path="client/src/components/Products.jsx" data-component-line="112:9" data-component-id={`client/src/components/Products.jsx:112:9-${product.name}`} className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
        <div data-component-path="client/src/components/Products.jsx" data-component-line="113:9" data-component-id={`client/src/components/Products.jsx:113:9-${product.name}`} className="flex items-baseline gap-2 mb-4">
          <span data-component-path="client/src/components/Products.jsx" data-component-line="114:11" data-component-id={`client/src/components/Products.jsx:114:11-${product.name}`} className="text-3xl font-bold text-green-600">${product.price}</span>
          <span data-component-path="client/src/components/Products.jsx" data-component-line="115:11" data-component-id={`client/src/components/Products.jsx:115:11-${product.name}`} className="text-gray-500">{product.unit}</span>
        </div>
        <button 
          data-component-path="client/src/components/Products.jsx" 
          data-component-line="118:11" 
          data-component-id={`client/src/components/Products.jsx:118:11-${product.name}`}
          onClick={() => handleAddToCart(product.name)}
          className="w-full h-11 px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2 font-medium shadow-md hover:shadow-lg transition-all duration-200 focus:ring-4 focus:ring-green-300/50"
        >
          <ShoppingCart data-component-path="client/src/components/Products.jsx" data-component-line="124:11" data-component-id={`client/src/components/Products.jsx:124:11-${product.name}`} className="w-5 h-5 flex-shrink-0" />
          Add to Cart
        </button>
      </div>
    </div>
  )

  return (
    <section data-component-path="client/src/components/Products.jsx" data-component-line="132:5" data-component-id="client/src/components/Products.jsx:132:5" id="products" className="py-20 bg-white">
      <div data-component-path="client/src/components/Products.jsx" data-component-line="133:7" data-component-id="client/src/components/Products.jsx:133:7" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Products.jsx" data-component-line="134:9" data-component-id="client/src/components/Products.jsx:134:9" className="mb-16">
          <h2 data-component-path="client/src/components/Products.jsx" data-component-line="135:11" data-component-id="client/src/components/Products.jsx:135:11" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Fresh Vegetables
          </h2>
          <p data-component-path="client/src/components/Products.jsx" data-component-line="138:11" data-component-id="client/src/components/Products.jsx:138:11" className="text-xl text-gray-600">
            Handpicked daily from local organic farms
          </p>
        </div>

        <div data-component-path="client/src/components/Products.jsx" data-component-line="143:9" data-component-id="client/src/components/Products.jsx:143:9" className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {vegetables.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </div>

        <div data-component-path="client/src/components/Products.jsx" data-component-line="149:9" data-component-id="client/src/components/Products.jsx:149:9" className="mb-16">
          <h2 data-component-path="client/src/components/Products.jsx" data-component-line="150:11" data-component-id="client/src/components/Products.jsx:150:11" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Fresh Fruits
          </h2>
          <p data-component-path="client/src/components/Products.jsx" data-component-line="153:11" data-component-id="client/src/components/Products.jsx:153:11" className="text-xl text-gray-600">
            Sweet, juicy, and packed with vitamins
          </p>
        </div>

        <div data-component-path="client/src/components/Products.jsx" data-component-line="158:9" data-component-id="client/src/components/Products.jsx:158:9" className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {fruits.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Products